<template lang="pug">
v-card(:to="to", width="100%", max-width="370px", flat)
  img.mb-1.product-card-img.rounded-lg(:src="img", :alt="title")
  .text-body-1.font-weight-bold.text-center.grey--text.text--darken-4.mb-2 {{ category }}
  .product-card-title.white--text.text-center.secondary.text-h6.d-flex.justify-center.align-center.mx-auto.rounded-0 {{ title }}
</template>

<script>
import Tooltip from "../tools/Tooltip.vue";

export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  components: {
    Tooltip,
  },
};
</script>

<style>
.product-card-title {
  max-width: 265px;
  height: 42px;
  position: relative;
}
.product-card-title::before,
.product-card-title::after {
  content: "";
  width: 0;
  position: absolute;
}
.product-card-title::before {
  border-bottom: 12px solid transparent;
  border-left: 12px solid white;
  top: 0;
  left: 0;
}
.product-card-title::after {
  border-top: 12px solid transparent;
  border-right: 12px solid white;
  bottom: 0;
  right: 0;
}
.product-card-img {
  aspect-ratio: 16/12;
  width: 100%;
  object-fit: contain;
}
</style>